export default __webpack_public_path__ + "static/realWorldImage2-525288ba526fbc934eb9a095087445c3.webp";